// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"259":"d80fda8d","399":"ceebc032","416":"2a5aff89","476":"21ca4cbb","783":"39c59fac","963":"cb75de28"}[chunkId] + ".chunk.css";
};